module.exports = __webpack_public_path__ + "img/sad-but-relieved-face.a6a4dcdc.png";